export const METHODOLOGY_VERSION = "eSF-1.0";

export const POSITION_DEFINITIONS = [
  ["AKT", "Suma bilansowa – aktywa", "Bilans/Aktywa", "balance", 0],
  ["AT", "Aktywa trwałe", "Bilans/Aktywa/Aktywa_A", "balance", 1],
  ["AT_NIER", "Inwestycje długoterminowe – nieruchomości", "Bilans/Aktywa/Aktywa_A/Aktywa_A_IV/Aktywa_A_IV_1", "balance", 2],
  ["AT_FIN", "Długoterminowe aktywa finansowe", "Bilans/Aktywa/Aktywa_A/Aktywa_A_IV/Aktywa_A_IV_3", "balance", 2],
  ["AO", "Aktywa obrotowe", "Bilans/Aktywa/Aktywa_B", "balance", 1],
  ["ZAP", "Zapasy", "Bilans/Aktywa/Aktywa_B/Aktywa_B_I", "balance", 2],
  ["NAL", "Należności krótkoterminowe", "Bilans/Aktywa/Aktywa_B/Aktywa_B_II", "balance", 2],
  ["NAL_DOST", "Należności z tytułu dostaw i usług", [
    "Bilans/Aktywa/Aktywa_B/Aktywa_B_II/Aktywa_B_II_1/Aktywa_B_II_1_A",
    "Bilans/Aktywa/Aktywa_B/Aktywa_B_II/Aktywa_B_II_2/Aktywa_B_II_2_A",
    "Bilans/Aktywa/Aktywa_B/Aktywa_B_II/Aktywa_B_II_3/Aktywa_B_II_3_A",
  ], "balance", 3],
  ["NAL_POD", "Należności publicznoprawne", "Bilans/Aktywa/Aktywa_B/Aktywa_B_II/Aktywa_B_II_3/Aktywa_B_II_3_B", "balance", 3],
  ["NAL_INNE", "Pozostałe należności", "Bilans/Aktywa/Aktywa_B/Aktywa_B_II/Aktywa_B_II_3/Aktywa_B_II_3_C", "balance", 3],
  ["INW_KR", "Inwestycje krótkoterminowe", "Bilans/Aktywa/Aktywa_B/Aktywa_B_III", "balance", 2],
  ["KAF", "Inne krótkoterminowe aktywa finansowe", "Bilans/Aktywa/Aktywa_B/Aktywa_B_III/Aktywa_B_III_1/Aktywa_B_III_1_B", "balance", 3],
  ["GOT", "Środki pieniężne i inne aktywa pieniężne", "Bilans/Aktywa/Aktywa_B/Aktywa_B_III/Aktywa_B_III_1/Aktywa_B_III_1_C", "balance", 3],
  ["RMK_A", "Krótkoterminowe rozliczenia międzyokresowe", "Bilans/Aktywa/Aktywa_B/Aktywa_B_IV", "balance", 2],
  ["PAS", "Suma bilansowa – pasywa", "Bilans/Pasywa", "balance", 0],
  ["KW", "Kapitał własny", "Bilans/Pasywa/Pasywa_A", "balance", 1],
  ["KW_POD", "Kapitał podstawowy", "Bilans/Pasywa/Pasywa_A/Pasywa_A_I", "balance", 2],
  ["KW_ZAP", "Kapitał zapasowy", "Bilans/Pasywa/Pasywa_A/Pasywa_A_II", "balance", 2],
  ["KW_ZLU", "Wynik z lat ubiegłych", "Bilans/Pasywa/Pasywa_A/Pasywa_A_V", "balance", 2],
  ["KW_WN", "Wynik netto roku obrotowego", "Bilans/Pasywa/Pasywa_A/Pasywa_A_VI", "balance", 2],
  ["ZOB", "Zobowiązania i rezerwy", "Bilans/Pasywa/Pasywa_B", "balance", 1],
  ["ZOB_D", "Zobowiązania długoterminowe", "Bilans/Pasywa/Pasywa_B/Pasywa_B_II", "balance", 2],
  ["KRED_D", "Kredyty i pożyczki długoterminowe", "Bilans/Pasywa/Pasywa_B/Pasywa_B_II/Pasywa_B_II_3/Pasywa_B_II_3_A", "balance", 3],
  ["ZOB_K", "Zobowiązania krótkoterminowe", "Bilans/Pasywa/Pasywa_B/Pasywa_B_III", "balance", 2],
  ["KRED_K", "Kredyty i pożyczki krótkoterminowe", "Bilans/Pasywa/Pasywa_B/Pasywa_B_III/Pasywa_B_III_3/Pasywa_B_III_3_A", "balance", 3],
  ["ZOB_DOST", "Zobowiązania z tytułu dostaw i usług", "Bilans/Pasywa/Pasywa_B/Pasywa_B_III/Pasywa_B_III_3/Pasywa_B_III_3_D", "balance", 3],
  ["ZOB_POD", "Zobowiązania publicznoprawne", "Bilans/Pasywa/Pasywa_B/Pasywa_B_III/Pasywa_B_III_3/Pasywa_B_III_3_G", "balance", 3],
  ["ZOB_WYN", "Zobowiązania z tytułu wynagrodzeń", "Bilans/Pasywa/Pasywa_B/Pasywa_B_III/Pasywa_B_III_3/Pasywa_B_III_3_H", "balance", 3],
  ["ZOB_INNE", "Pozostałe zobowiązania", "Bilans/Pasywa/Pasywa_B/Pasywa_B_III/Pasywa_B_III_3/Pasywa_B_III_3_I", "balance", 3],
  ["PRZ", "Przychody netto ze sprzedaży", "RZiS/RZiSPor/A", "income", 0],
  ["PRZ_PROD", "Przychody ze sprzedaży produktów", "RZiS/RZiSPor/A/A_I", "income", 1],
  ["PRZ_TOW", "Przychody ze sprzedaży towarów i materiałów", "RZiS/RZiSPor/A/A_IV", "income", 1],
  ["KOP", "Koszty działalności operacyjnej", "RZiS/RZiSPor/B", "income", 0],
  ["AM", "Amortyzacja", "RZiS/RZiSPor/B/B_I", "income", 1],
  ["MAT", "Zużycie materiałów i energii", "RZiS/RZiSPor/B/B_II", "income", 1],
  ["USL", "Usługi obce", "RZiS/RZiSPor/B/B_III", "income", 1],
  ["POD_OPL", "Podatki i opłaty", "RZiS/RZiSPor/B/B_IV", "income", 1],
  ["WYN", "Wynagrodzenia", "RZiS/RZiSPor/B/B_V", "income", 1],
  ["UBEZ", "Ubezpieczenia społeczne i świadczenia", "RZiS/RZiSPor/B/B_VI", "income", 1],
  ["POZ_ROD", "Pozostałe koszty rodzajowe", "RZiS/RZiSPor/B/B_VII", "income", 1],
  ["WST", "Wartość sprzedanych towarów i materiałów", "RZiS/RZiSPor/B/B_VIII", "income", 1],
  ["ZS", "Zysk (strata) ze sprzedaży", "RZiS/RZiSPor/C", "income", 0],
  ["PPO", "Pozostałe przychody operacyjne", "RZiS/RZiSPor/D", "income", 0],
  ["PKO", "Pozostałe koszty operacyjne", "RZiS/RZiSPor/E", "income", 0],
  ["EBIT", "Wynik z działalności operacyjnej", "RZiS/RZiSPor/F", "income", 0],
  ["PF", "Przychody finansowe", "RZiS/RZiSPor/G", "income", 0],
  ["KF", "Koszty finansowe", "RZiS/RZiSPor/H", "income", 0],
  ["ODS", "Odsetki w kosztach finansowych", "RZiS/RZiSPor/H/H_I", "income", 1],
  ["ZB", "Zysk (strata) brutto", "RZiS/RZiSPor/I", "income", 0],
  ["CIT", "Podatek dochodowy", "RZiS/RZiSPor/J", "income", 0],
  ["ZN", "Zysk (strata) netto", "RZiS/RZiSPor/L", "income", 0],
].map(([symbol, label, paths, group, level]) => ({
  symbol,
  label,
  paths: Array.isArray(paths) ? paths : [paths],
  group,
  level,
}));

const POSITION_BY_SYMBOL = Object.fromEntries(
  POSITION_DEFINITIONS.map((definition) => [definition.symbol, definition])
);

function normalizedPath(row) {
  const suffix = String(row.path || "").replace(/\./g, "/").replace(/^\/+/, "");
  return `${row.section}/${suffix}`.replace(/\/+/, "/");
}

function numberOrNull(value) {
  if (value === null || value === undefined || value === "") return null;
  const number = Number(value);
  return Number.isFinite(number) ? number : null;
}

export function buildFinancialSeries(statements) {
  const years = new Map();
  const overlaps = [];

  const ensureYear = (year) => {
    if (!years.has(year)) {
      years.set(year, { year, values: {}, sources: [], priorities: {} });
    }
    return years.get(year);
  };

  const applyRows = (statement, year, amountField, priority, sourceKind) => {
    if (!Number.isInteger(year)) return;
    const target = ensureYear(year);
    const source = {
      id: statement._id,
      fileName: statement.fileName,
      sourceKind,
      periodTo: statement.metadata?.periodTo,
    };
    if (!target.sources.some((item) => item.id === source.id && item.sourceKind === sourceKind)) {
      target.sources.push(source);
    }

    (statement.financialRows || []).forEach((row) => {
      const value = numberOrNull(row[amountField]);
      if (value === null) return;
      const path = normalizedPath(row);
      const existing = target.values[path];
      const existingPriority = target.priorities[path] || 0;

      if (existing !== undefined && Math.abs(existing - value) > 0.01) {
        overlaps.push({
          year,
          path,
          directValue: priority >= existingPriority ? value : existing,
          comparativeValue: priority >= existingPriority ? existing : value,
          difference: value - existing,
          fileName: statement.fileName,
        });
      }

      if (existing === undefined || priority > existingPriority) {
        target.values[path] = value;
        target.priorities[path] = priority;
      }
    });
  };

  [...statements]
    .sort((a, b) => String(a.metadata?.periodTo).localeCompare(String(b.metadata?.periodTo)))
    .forEach((statement) => {
      const currentYear = Number.parseInt(String(statement.metadata?.periodTo || "").slice(0, 4), 10);
      if (!Number.isInteger(currentYear)) return;
      // The newest filing's comparative column represents the restated basis
      // used in that filing, so it takes precedence over the older closing value.
      applyRows(statement, currentYear, "amountB", 2, "current");
      applyRows(statement, currentYear - 1, "amountA", 3, "comparative-restated");
    });

  const result = [...years.values()]
    .map(({ priorities, ...year }) => year)
    .sort((a, b) => a.year - b.year);
  return { years: result, overlaps };
}

export function getPosition(yearData, symbol) {
  const definition = POSITION_BY_SYMBOL[symbol];
  if (!definition || !yearData) return 0;
  return definition.paths.reduce((sum, path) => sum + (yearData.values[path] || 0), 0);
}

function divide(numerator, denominator) {
  if (!Number.isFinite(numerator) || !Number.isFinite(denominator) || denominator === 0) return null;
  return numerator / denominator;
}

function average(current, previous) {
  return previous === null || previous === undefined ? current : (current + previous) / 2;
}

function metric(code, label, value, unit, interpretation, tone = "neutral") {
  return { code, label, value: Number.isFinite(value) ? value : null, unit, interpretation, tone };
}

function highIsGood(value, good, warning) {
  if (value === null) return "neutral";
  if (value >= good) return "good";
  if (value >= warning) return "warning";
  return "bad";
}

export function calculateYearMetrics(yearData, previousYearData = null) {
  const p = (symbol) => getPosition(yearData, symbol);
  const pp = (symbol) => (previousYearData ? getPosition(previousYearData, symbol) : null);
  const hasComparative = Boolean(previousYearData);

  const revenue = p("PRZ");
  const operatingCosts = p("KOP");
  const ebit = p("EBIT");
  const depreciation = p("AM");
  const ebitda = ebit + depreciation;
  const netProfit = p("ZN");
  const totalAssets = p("AKT");
  const equity = p("KW");
  const currentAssets = p("AO");
  const inventory = p("ZAP");
  const shortInvestments = p("INW_KR");
  const shortLiabilities = p("ZOB_K");
  const liabilities = p("ZOB");
  const fixedAssets = p("AT");
  const interest = p("ODS");
  const debt = p("KRED_D") + p("KRED_K");
  const netDebt = debt - shortInvestments;
  const workingCapital = currentAssets - shortLiabilities;
  const avgAssets = average(totalAssets, pp("AKT"));
  const avgEquity = average(equity, pp("KW"));
  const avgReceivables = average(p("NAL"), pp("NAL"));
  const avgTradeReceivables = average(p("NAL_DOST"), pp("NAL_DOST"));
  const avgInventory = average(inventory, pp("ZAP"));
  const avgPayables = average(p("ZOB_DOST"), pp("ZOB_DOST"));
  const currentRatio = divide(currentAssets, shortLiabilities);
  const quickRatio = divide(currentAssets - inventory, shortLiabilities);
  const cashRatio = divide(shortInvestments, shortLiabilities);
  const debtRatio = divide(liabilities, totalAssets);
  const equityRatio = divide(equity, totalAssets);
  const asDays = (ratio) => (ratio === null ? null : ratio * 365);
  const dso = asDays(divide(avgReceivables, revenue));
  const tradeDso = asDays(divide(avgTradeReceivables, revenue));
  const inventoryDays = asDays(divide(avgInventory, operatingCosts));
  const payableDays = asDays(divide(avgPayables, operatingCosts));
  const cashConversion =
    [dso, inventoryDays, payableDays].every(Number.isFinite)
      ? dso + inventoryDays - payableDays
      : null;

  const profitability = [
    metric("W01", "Marża zysku ze sprzedaży", divide(p("ZS"), revenue), "%", "Rentowność podstawowej działalności", divide(p("ZS"), revenue) >= 0 ? "good" : "bad"),
    metric("W02", "Marża operacyjna", divide(ebit, revenue), "%", "Wynik operacyjny do przychodów", divide(ebit, revenue) >= 0 ? "good" : "bad"),
    metric("W03", "EBITDA", ebitda, "PLN", "EBIT powiększony o amortyzację", ebitda >= 0 ? "good" : "bad"),
    metric("W04", "Marża EBITDA", divide(ebitda, revenue), "%", "EBITDA do przychodów", divide(ebitda, revenue) >= 0 ? "good" : "bad"),
    metric("W05", "Marża brutto", divide(p("ZB"), revenue), "%", "Wynik przed opodatkowaniem", divide(p("ZB"), revenue) >= 0 ? "good" : "bad"),
    metric("W06", "Marża netto", divide(netProfit, revenue), "%", "Podstawowa miara rentowności", divide(netProfit, revenue) >= 0 ? "good" : "bad"),
    metric("W07", "ROA – stan końcowy", divide(netProfit, totalAssets), "%", "Zwrot z aktywów", divide(netProfit, totalAssets) >= 0 ? "good" : "bad"),
    metric("W08", "ROA – stan średni", hasComparative ? divide(netProfit, avgAssets) : null, "%", hasComparative ? "Wersja na średnim stanie" : "Wymaga poprzedniego bilansu"),
    metric("W09", "ROE – stan końcowy", equity > 0 ? divide(netProfit, equity) : null, "%", equity > 0 ? "Zwrot z kapitału własnego" : "Brak sensu przy niedodatnim kapitale"),
    metric("W10", "ROE – stan średni", hasComparative && avgEquity > 0 ? divide(netProfit, avgEquity) : null, "%", hasComparative ? "Wersja na średnim stanie" : "Wymaga poprzedniego bilansu"),
  ];

  const liquidity = [
    metric("W11", "Płynność bieżąca", currentRatio, "x", "Norma 1,2–2,0; powyżej 3,0 oznacza nadpłynność", currentRatio > 3 ? "warning" : highIsGood(currentRatio, 1.2, 1)),
    metric("W12", "Płynność szybka", quickRatio, "x", "Orientacyjna norma około 1,0", quickRatio > 3 ? "warning" : highIsGood(quickRatio, 1, 0.8)),
    metric("W13", "Płynność gotówkowa", cashRatio, "x", "Inwestycje krótkoterminowe do zobowiązań bieżących", cashRatio > 1 ? "warning" : highIsGood(cashRatio, 0.1, 0.05)),
    metric("W14", "Kapitał obrotowy netto", workingCapital, "PLN", "Aktywa obrotowe minus zobowiązania krótkoterminowe", workingCapital >= 0 ? "good" : "bad"),
    metric("W15", "KON w aktywach", divide(workingCapital, totalAssets), "%", "Udział kapitału obrotowego netto w aktywach"),
  ];

  const leverage = [
    metric("W16", "Zadłużenie ogólne", debtRatio, "%", "Norma do 67%; ponad 80% oznacza wysokie ryzyko", debtRatio > 0.8 ? "bad" : debtRatio > 0.67 ? "warning" : "good"),
    metric("W17", "Zobowiązania / kapitał własny", equity > 0 ? divide(liabilities, equity) : null, "%", "Wartość niedostępna przy niedodatnim kapitale"),
    metric("W18", "Wskaźnik samofinansowania", equityRatio, "%", "Kapitał własny do aktywów", highIsGood(equityRatio, 0.5, 0.33)),
    metric("W19", "Pokrycie aktywów trwałych", fixedAssets > 0 ? divide(equity, fixedAssets) : null, "%", fixedAssets > 0 ? "Złota reguła: powyżej 100%" : "Brak aktywów trwałych"),
    metric("W20", "Pokrycie odsetek", interest > 0 ? divide(ebit, interest) : null, "x", interest > 0 ? "Banki oczekują zwykle powyżej 3x" : "Brak kosztów odsetkowych", interest > 0 ? highIsGood(divide(ebit, interest), 3, 1) : "good"),
    metric("W21", "Dług oprocentowany", debt, "PLN", "Kredyty i pożyczki długo- i krótkoterminowe"),
    metric("W22", "Dług netto", netDebt, "PLN", netDebt < 0 ? "Ujemny oznacza pozycję gotówkową netto" : "Dług po pomniejszeniu o inwestycje krótkoterminowe", netDebt <= 0 ? "good" : "warning"),
    metric("W23", "Dług netto / EBITDA", ebitda > 0 ? divide(netDebt, ebitda) : null, "x", ebitda > 0 ? "Kowenant bankowy zwykle poniżej 3,5x" : "Niedostępny przy niedodatniej EBITDA"),
    metric("W24", "Udział zobowiązań krótkoterminowych", divide(shortLiabilities, liabilities), "%", "Wysoki udział zwiększa presję na płynność"),
  ];

  const efficiency = [
    metric("W25", "Cykl należności", dso, "days", "Liczony od przychodów netto; ponad 90 dni to ostrzeżenie", dso > 120 ? "bad" : dso > 90 ? "warning" : "good"),
    metric("W26", "Cykl należności handlowych", tradeDso, "days", "Węższa miara rzeczywistego terminu zapłaty"),
    metric("W27", "Cykl zapasów", inventoryDays, "days", "Dla firm usługowych może być bliski zeru"),
    metric("W28", "Cykl zobowiązań", payableDays, "days", "Porównuj z cyklem należności"),
    metric("W29", "Cykl konwersji gotówki", cashConversion, "days", "Dni finansowania cyklu operacyjnego"),
    metric("W30", "Rotacja aktywów", hasComparative ? divide(revenue, avgAssets) : null, "x", hasComparative ? "Przychody generowane przez jednostkę aktywów" : "Wymaga poprzedniego bilansu"),
    metric("W31", "Rotacja kapitału własnego", hasComparative && avgEquity > 0 ? divide(revenue, avgEquity) : null, "x", hasComparative ? "Czynnik analizy DuPont" : "Wymaga poprzedniego bilansu"),
  ];

  return {
    year: yearData.year,
    revenue,
    operatingCosts,
    ebit,
    ebitda,
    netProfit,
    totalAssets,
    equity,
    currentRatio,
    debtRatio,
    profitability,
    liquidity,
    leverage,
    efficiency,
    allMetrics: [...profitability, ...liquidity, ...leverage, ...efficiency],
  };
}

export function calculateAllMetrics(years) {
  return years.map((year, index) => calculateYearMetrics(year, years[index - 1] || null));
}

export function buildQualityChecks(years, overlaps) {
  const checks = [];
  years.forEach((year) => {
    const assets = getPosition(year, "AKT");
    const liabilitiesAndEquity = getPosition(year, "PAS");
    const netIncome = getPosition(year, "ZN");
    const balanceNetIncome = getPosition(year, "KW_WN");
    checks.push({
      label: `Bilans ${year.year}: aktywa = pasywa`,
      difference: assets - liabilitiesAndEquity,
      ok: Math.abs(assets - liabilitiesAndEquity) <= 0.01,
    });
    checks.push({
      label: `Wynik netto ${year.year}: RZiS = bilans`,
      difference: netIncome - balanceNetIncome,
      ok: Math.abs(netIncome - balanceNetIncome) <= 0.01,
    });
  });
  return {
    checks,
    overlapIssues: overlaps.filter((item) => Math.abs(item.difference) > 0.01),
    passed: checks.every((check) => check.ok) && overlaps.every((item) => Math.abs(item.difference) <= 0.01),
  };
}
